// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { AddURLLinkParams, urlLinkSchema } from '@/url-link/api/types';
import { z } from 'zod';

const addReturnOrderURLLinkResponseSchema = z
  .object({
    data: urlLinkSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, ...data }));

type AddReturnOrderURLLinkResponse = z.infer<
  typeof addReturnOrderURLLinkResponseSchema
>;

export async function addReturnOrderURLLink(
  params: AddURLLinkParams
): Promise<AddReturnOrderURLLinkResponse> {
  const apiUrl = `/v1/return-order/${params.entityKey}/url-link`;
  const payload = {
    name: params.name,
    url: params.url,
  };

  const response = await api.post(apiUrl, payload);

  return parseResponse(addReturnOrderURLLinkResponseSchema, response.data, {
    schemaName: 'AddReturnOrderURLLink',
    endpoint: apiUrl,
  });
}
